<template>
	<hr :class="['divider', ...variantClassList]" />
</template>

<script>
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/divider-variant-classes';

export default {
	name: 'Divider',
	mixins: [componentVariantMixin],
	created() {
		this.variantClasses = variantClasses;
	}
};
</script>

<style lang="scss" scoped>
.divider {
	width: 100%;
	margin-block-start: 0;
	margin-block-end: 0;
	margin-inline-start: auto;
	margin-inline-end: auto;
	border: 0;
	height: 1px;
	background: var(--bg-2);

	&--vertical {
		width: 1px;
		height: auto;
		min-height: 100%;
	}

	&--dashed {
		height: 2px;
		background: repeating-linear-gradient(
			to right,
			var(--bg-2),
			var(--bg-2) 2px,
			transparent 2px,
			transparent 8px
		);
	}
}
</style>
